import * as fetchAdapter from 'common/adapters/FetchAdapter'
import { CONTENT_API_BASE_URL } from 'configs/rest'

export const getGeoPosition = () => {
    return fetchAdapter.get(CONTENT_API_BASE_URL + '/core/geo.php')
}
